import { takeEvery, takeLatest, all } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import { filingListRequest, filingListCorrectionRequest } from '@store/filingList';

export default all([
  takeLatest(filingListRequest.type, handleRequest),
  takeEvery(filingListCorrectionRequest.type, handleRequest),
]);
